export const RESCHEDULE_NOTICE_HOURS = 12;
